import actionCreatorFactory from 'typescript-fsa'
const actionCreator = actionCreatorFactory()

export const receiveRoomList = actionCreator<string[]>(
  'ACTIONS_RECEIVE_ROOM_LIST',
)
